import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { stageLabel } from "@/lib/charts";

// Move applications to a stage and offer a 5s Undo that restores their previous stages.
export async function moveWithUndo(ids, stage, onChange) {
  try {
    const { data } = await api.post("/applications/move", { application_ids: ids, stage });
    onChange();
    toast.success(`Moved ${data.moved} candidate${data.moved === 1 ? "" : "s"} to ${stageLabel(stage)}`, {
      duration: 5000,
      action: {
        label: "Undo",
        onClick: async () => {
          await api.post("/applications/restore", { previous: data.previous });
          onChange();
          toast("Move undone");
        },
      },
    });
  } catch (e) {
    toast.error(errMsg(e));
  }
}
